<canvas
  #canvas
  width="300"
  height="300"
></canvas>
<div class="d-flex justify-content-center mb-2">
  <a class="btn btn-dark text-light" (click)="clearPad()">Effacer</a>
  <a *ngIf="is_modal" class="btn btn-success text-light ml-2" (click)="savePad()">Enregistrer</a>
</div>
